export enum BetTicketStatus {
    NOT_PROCESSED = 'place',
    LOST = 'perdu',
    PROCESSED = 'process',
    DISABLED = 'disabled',
    VALID = 'valid',
    INVALID = 'non_valid',
    CANCELLED = 'cancel',
    ENABLED = 'enable',
    PAID = 'paye',
    WON = 'gagnant',
    REJECTED = 'rejected',
    CALCULATED = 'cloturer',
    SUSPENDED = 'suspended'
}